import { ApiResponse, DataArray, DataObject, DataPaginate } from "@/types";
import {
  ElectoralDistrictDetailResponse,
  ElectoralDistrictResponse,
  ElectoralDistrictTotalUserResponse,
} from "./interface";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { useFormMutation } from "@/hooks/useFormMutation";
import { ElectoralDistrictPayload } from "./validation";

// get list
const getElectoralDistrict = async (
  query?: string
): Promise<ApiResponse<DataPaginate<ElectoralDistrictResponse>>> => {
  return await fetcher(`master/dapil?${query}`);
};

export const useElectoralDistrict = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<ElectoralDistrictResponse>>, Error>({
    queryKey: ["useElectoralDistrict", query],
    queryFn: () => getElectoralDistrict(query),
  });
};

// get detail
const getElectoralDistrictDetail = async (
  id: number
): Promise<ApiResponse<DataObject<ElectoralDistrictDetailResponse>>> => {
  return await fetcher(`master/dapil/${id}`);
};

export const useElectoralDistrictDetail = (id: number) => {
  return useQuery<
    ApiResponse<DataObject<ElectoralDistrictDetailResponse>>,
    Error
  >({
    queryKey: ["useElectoralDistrictDetail", id],
    queryFn: () => getElectoralDistrictDetail(id),
  });
};

// Get List Total User
const getElectoralDistrictTotalUser = async (): Promise<
  ApiResponse<DataArray<ElectoralDistrictTotalUserResponse>>
> => {
  return await fetcher(`master/dapil/user/total`);
};

export const useElectoralDistrictTotalUser = () => {
  return useQuery<
    ApiResponse<DataArray<ElectoralDistrictTotalUserResponse>>,
    Error
  >({
    queryKey: ["useElectoralDistrictTotalUser"],
    queryFn: () => getElectoralDistrictTotalUser(),
  });
};

// Mutation
export const useElectoralDistrictMutation = (
  method: "POST" | "PUT" = "POST",
  id?: number
) => {
  return useFormMutation<
    ApiResponse<DataObject<ElectoralDistrictResponse>>,
    Error,
    ElectoralDistrictPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<ElectoralDistrictResponse>>> => {
      const endpoint = id ? `master/dapil/${id}` : "master/dapil";
      const response: ApiResponse<DataObject<ElectoralDistrictResponse>> =
        await sendData(endpoint, data, method);
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
